import React, { useEffect, useState } from 'react';
import { ROUTE } from 'constant';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';
import {
  toInt,
  _t,
  pushHistory,
  copyToClipboard,
} from 'utils';
import { useNotification } from 'screens/shared/hooks/notifications';
import CreateForm from './create';

const MongodbList = ({ history }) => {
  const dispatch = useDispatch();
  const [trigger, setTrigger] = useState(0);
  const [,, setNotification] = useNotification({});
  const {
    [ACTIONS_TYPES.DATABASE.MONGODB.GET_ALL]: inputClusters = [],
    // [ACTIONS_TYPES.COMMON.BUFFER_CLONE_DATA]: cloneData = null,
    [ACTIONS_TYPES.DATABASE.GET_QUOTA]: dbQuota = {},
  } = useSelector((e) => e);

  const clusters = inputClusters.map(({ id, properties, metadata }) => ({
    ...properties,
    id,
    state: metadata.state,
    health: metadata.health,
  }));

  const { quotaUsage = {}, quotaLimits = {} } = dbQuota || {};
  const maxCulters = toInt(quotaLimits?.['count/postgresclusters.dbaas.ionos.com'], 5) - toInt(quotaUsage?.['count/postgresclusters.dbaas.ionos.com']);

  const clickHandler = ({ id: clusterId }) => {
    pushHistory({ history, path: ROUTE.DASHBOARD.DBAAS_MONGODB.path.replace(':id', clusterId) });
  };

  const refreshAll = () => {
    actions.database.getQuota();
    return actions.database.mongodb.getAll();
  };

  const onCloseAddForm = () => {
    dispatch({
      type: ACTIONS_TYPES.COMMON.BUFFER_CLONE_DATA,
      payload: null,
    });
  };

  const onCancelCreate = () => {
    setTrigger(1);
    setTimeout(() => {
      setTrigger(0);
    }, 10);
  };

  useEffect(() => {
    actions.database.mongodb.getAll();
  }, []);

  const canCreateCluster = maxCulters > 0;

  return (
    <Shared.widgets.Section
      isAddButton={canCreateCluster}
      showAddForm={!!trigger}
      onCloseAddForm={onCloseAddForm}
      sectionTitle={_t('DATABASES.MONGODB.SECTION_TITLE')}
      createForm={<CreateForm onCancel={onCancelCreate} />}
      createActionType={ACTIONS_TYPES.DATABASE.MONGODB.CREATE}
      itemOnClick={clickHandler}
      itemIcon="database"
      setItemTitle={(e) => e.displayName}
      setItemDetails={(e) => (
        <span>
          <Shared.utilities.Location location={e.location} />
          <div>
            <span className="m-r-5">
              {_t('DATABASES.MONGODB.STATE')}
            </span>
            <Shared.utilities.StatusText state={e.state} />
          </div>
          <div>
            <span className="m-r-5">
              {_t('DATABASES.MONGODB.HEALTH_STATE')}
            </span>
            <Shared.utilities.StatusText state={e.health} />
          </div>
        </span>
      )}
      actionButtons={[
        {
          icon: 'copy',
          tooltip: _t('DATABASES.MONGODB.ACTION_TEXTS.CONNECTION_COPY'),
          onClick: (e, item) => {
            e.stopPropagation();
            e.preventDefault();
            copyToClipboard(item.connectionString);
            setNotification({
              type: 'success',
              message: _t('DATABASES.MONGODB.ACTION_TEXTS.CONNECTION_COPIED'),
            });
          },
        },
        {
          icon: 'users',
          tooltip: 'User Management',
          onClick: () => {
            const main = document.getElementsByTagName('main')[0];
            main.scrollTop = 0;
          },
        },
      ]}
      items={clusters}
      tableColumns={['', 'Name', 'Location']}
      refresh={refreshAll}
      scrollIntoForm
    />
  );
};

export default MongodbList;
